import { AppInsights, debug } from '@bechtel/client-common';
import { createRoot } from 'react-dom/client';
import { setConfig } from 'react-hot-loader';
import { AZURE_INSIGHTS_KEY, DEBUG, NODE_ENV } from '~/env-config';
import App from './app';

if (NODE_ENV !== 'production') {
  setConfig({
    reloadHooks: false,
  });
}
if (DEBUG === 'true') {
  if (!localStorage.getItem('debug')) {
    localStorage.setItem('debug', 'bps-web:*');
  }
}
if (NODE_ENV !== 'development' && AZURE_INSIGHTS_KEY) {
  try {
    AppInsights().loadAppInsights();
    AppInsights().trackEvent({ name: 'Application Launch' });
  } catch (error) {
    debug.error(error);
  }
}
const container = document.getElementById('app');
const root = createRoot(container!);
root.render(<App />);
